import { ReactNode } from 'react';
import { Sidebar } from './components/Sidebar';
import { Header } from './components/Header';
import { useAppSelector } from '@/app/stores/store';
import { cn } from '@/lib/utils';

interface MainLayoutProps {
  children: ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  const language = useAppSelector((state) => state.ui.language);
  const isRTL = language === 'ar';

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <Sidebar />
      <div className="flex min-h-0 flex-1 flex-col">
        <Header />
        <main
          className={cn(
            'relative z-0 min-h-0 flex-1 overflow-y-auto bg-gradient-to-b from-background to-muted/70 p-4 transition-all duration-300 sm:p-6',
            isRTL ? 'lg:mr-64' : 'lg:ml-64',
          )}
        >
          {children}
        </main>
      </div>
    </div>
  );
}

